
import React from "react";
import i18next from "i18next";
import { Grid } from "@mui/material";
import RuleSelectInput from "components/rules/RuleSelectInput";
import { statusEngCode } from "services/common/Constants";
import { RuleActionParameterNames } from "services/common/RulesUtils";


const DocumentStatusChangeParams = ({ fieldName, readOnly = false }) => {
  return (
    <Grid container spacing={2} style={{ alignItems: "center", justifyContent: "center" }}>
      <Grid item xs={12} md={8}>
        <RuleSelectInput
            fieldName={`${fieldName}.${RuleActionParameterNames.DOCUMENT_STATUS_CODE}`}
            label={`${i18next.t("rules.configuration.ruleActions.fields.parameters.documentStatus.label")}`}
            placeholder={i18next.t(`rules.configuration.ruleActions.fields.parameters.documentStatus.placeholder`)}
            options={[
              {
                value: 'ACTION_REQUIRED',
                label: i18next.t(
                  `viewer.status.statusLabel.${statusEngCode.ACTION_REQUIRED}`
                )
              },
              {
                value: 'BELOW_EXPECTATION',
                label: i18next.t(
                  `viewer.status.statusLabel.${statusEngCode.BELOW_EXPECTATION}`
                )
              },
              {
                value: 'NOT_VALID',
                label: i18next.t(
                  `viewer.status.statusLabel.${statusEngCode.NOT_VALID}`
                ),
              },
              {
                value: 'VALID',
                label: i18next.t(
                  `viewer.status.statusLabel.${statusEngCode.VALID}`
                )
              }
            ]}
            onChange={() => { }}
            isRequired
            validate={() => {return null;}}
            labelVariant='chip'
            disabled={readOnly}
        />
      </Grid >
    </Grid >
  );
}

export default DocumentStatusChangeParams;
